<template>
  <div>
    <el-dropdown @command="command">
      <slot name="actions-trigger">
        <span class="el-dropdown-link more">
          <i class="eden-icon-more"></i>
        </span>
      </slot>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :icon="'eden-icon-user'" :command="'status'"
          >Change company status</el-dropdown-item
        >
        <el-dropdown-item :icon="'eden-icon-delete'" :command="'delete'"
          >Delete company</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <component
      :is="action.component"
      :show.sync="action.visibility"
      :company="company"
      @success="$emit('update', action.command)"
    />
  </div>
</template>

<script>
export default {
  name: "CompanyActions",
  props: {
    company: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    CompanyStatus: () => import("./CompanyStatus"),
    CompanyDelete: () => import("./CompanyDelete"),
  },

  data() {
    return {
      action: {
        component: "",
        command: "",
        visibility: false,
      },
    };
  },
  computed: {},
  methods: {
    command(command) {
      this.action.component = `company-${command}`;
      this.action.command = command;
      setTimeout(() => {
        this.action.visibility = true;
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped></style>
